/**
 * API Client - SIMPLE, DIRECT, NO BULLSHIT
 */

import axios from 'axios';
import { useAuthStore } from '@store/authStore';
import { buildURL } from '../config/services';

// Create axios instance with interceptors
const axiosInstance = axios.create();

// Response interceptor for handling 401 errors
axiosInstance.interceptors.response.use(
  (response) => response, // Pass through successful responses
  (error) => {
    // Handle 401 Unauthorized (token expired)
    if (error.response?.status === 401) {
      console.warn('🔒 Token expired - logging out');
      
      // Logout user
      useAuthStore.getState().logout();
      
      // Redirect to login
      window.location.href = '/auth/login';
    }
    
    // Pass through other errors
    return Promise.reject(error);
  }
);

// Create custom API object that routes correctly
export const api = {
  get: async (url: string, config?: any) => {
    const fullURL = buildURL(url);
    const token = useAuthStore.getState().accessToken;
    
    console.log(`🔄 GET ${fullURL}`); // Debug
    
    return axiosInstance.get(fullURL, {
      ...config,
      headers: {
        ...config?.headers,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  },
  
  post: async (url: string, data?: any, config?: any) => {
    const fullURL = buildURL(url);
    const token = useAuthStore.getState().accessToken;
    
    console.log(`🔄 POST ${fullURL}`); // Debug
    
    return axiosInstance.post(fullURL, data, {
      ...config,
      headers: {
        ...config?.headers,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  },
  
  put: async (url: string, data?: any, config?: any) => {
    const fullURL = buildURL(url);
    const token = useAuthStore.getState().accessToken;
    
    console.log(`🔄 PUT ${fullURL}`); // Debug
    
    return axiosInstance.put(fullURL, data, {
      ...config,
      headers: {
        ...config?.headers,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  },
  
  delete: async (url: string, config?: any) => {
    const fullURL = buildURL(url);
    const token = useAuthStore.getState().accessToken;
    
    console.log(`🔄 DELETE ${fullURL}`); // Debug
    
    return axiosInstance.delete(fullURL, {
      ...config,
      headers: {
        ...config?.headers,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  },
  
  patch: async (url: string, data?: any, config?: any) => {
    const fullURL = buildURL(url);
    const token = useAuthStore.getState().accessToken;
    
    console.log(`🔄 PATCH ${fullURL}`); // Debug
    
    return axiosInstance.patch(fullURL, data, {
      ...config,
      headers: {
        ...config?.headers,
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  },
};


// API Response type
export interface ApiResponse<T = any> {
  success: boolean;
  message?: string;
  data?: T;
  error?: {
    code: string;
    message: string;
    details?: any;
  };
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  timestamp: string;
}

export default api;

